export default "__VITE_ASSET__DBFWVA_d__"